import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import AlumnoHeader from '../../../components/AlumnoHeader/AlumnoHeader'
import DatosAcceso from './components/DatosAcceso/DatosAcceso'
import DatosUuid from './components/DatosUuid/DatosUuid'
import PageLoading from '../../../components/PageLoading/PageLoading'
import useAlumno from '../../../hooks/useAlumno'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import {
  createAccesoClassfy,
  getAccesoClassfy
} from '../../../utils/api/accesoClassfy'
import ConfigurarAcceso from './components/ConfigurarAcceso/ConfigurarAcceso'
import SesionesClassfy from './components/SesionesClassfy/SesionesClassfy'
import css from './Classfy.module.css'

const Classfy = () => {
  const { id } = useAlumno()
  const queryClient = useQueryClient()
  const notification = useNotification()

  const { isLoading, data: accesoAlumno = {} } = useQuery({
    queryKey: ['classfy', 'acceso-classfy', id],
    queryFn: () =>
      getAccesoClassfy(id).catch(err => {
        if (
          err ===
          'No se ha encontrado ningún documento con los datos especificados'
        )
          return {}
        notification.error({
          title: 'Error obteniendo los datos de Classfy',
          content: err
        })
        return {}
      })
  })

  const { isPending: isCreatingAccess, mutate: crearAcceso } = useMutation({
    mutationFn: createAccesoClassfy,
    onSuccess: () => {
      notification.success({
        title: 'Acceso creado',
        content: 'Se ha creado el acceso correctamente'
      })
      queryClient.invalidateQueries({
        queryKey: ['classfy', 'acceso-classfy', id]
      })
    },
    onError: err => {
      notification.error({
        title: 'Error creando acceso a Classfy',
        content: err
      })
    }
  })

  const handleCreateAccess = ({ email }) => {
    if (isCreatingAccess) return
    crearAcceso({ cliente: id, email })
  }

  const isAcceso = accesoAlumno && accesoAlumno.id

  return (
    <PageLoading isLoading={isLoading}>
      <div className={css.main}>
        <AlumnoHeader label='Classfy' />
        <div className={css.content}>
          {!isAcceso && (
            <div className={css.accordion}>
              <ConfigurarAcceso onSubmit={handleCreateAccess} />
            </div>
          )}
          {isAcceso && (
            <>
              <div className={css.accordion}>
                <DatosUuid accesoAlumno={accesoAlumno} />
              </div>
              <div className={css.accordion}>
                <DatosAcceso accesoAlumno={accesoAlumno} />
              </div>
              <div className={css.accordion}>
                <SesionesClassfy alumnoId={id} />
              </div>
            </>
          )}
        </div>
      </div>
    </PageLoading>
  )
}

export default Classfy
